import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white h-[500px] shadow-md p-[10px] relative rounded-lg" }
const _hoisted_2 = { class: "w-[40px] flex justify-center items-center h-[40px] rounded-[50%] text-white bg-cyan-700" }
const _hoisted_3 = { class: "font-bold uppercase" }
const _hoisted_4 = { class: "w-full relative shadown h-[250px] overflow-hidden my-[10px]" }
const _hoisted_5 = { class: "text-xl my-[10px] font-semibold" }
const _hoisted_6 = { class: "text-gray-800" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-full absolute bottom-[30px] left-0 h-[150px] max-h-[150px] overflow-hidden flex justify-start items-start" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full left-0 right-0 p-[10px] text-black bg-gray-200 bottom-0 flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1)

import { ref, watch } from 'vue';
import HeartIcon from './HeartIcon.vue';
import NewsDetail from '@/components/types/NewsDetail';

export default /*#__PURE__*/_defineComponent({
  __name: 'One_news',
  props: {
    news: {}
  },
  setup(__props: any) {

const props = __props;

const sortedNews = ref<NewsDetail[]>([]);

watch(() => props.news, () => {
    sortedNews.value = props.news.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedNews.value, (newsDetail, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "cursor-pointer shadow-4xl w-[350px] md:w-[320px] max-w-[90%] m-[10px]",
      key: index
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(newsDetail.id), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: { name: 'newsDetail', params: { id: newsDetail.id }},
              class: "hover:text-black hover:underline duration-300"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(newsDetail.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("div", {
              innerHTML: newsDetail.content
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: newsDetail.image,
            alt: "",
            class: "w-full h-full"
          }, null, 8, _hoisted_9)
        ]),
        _hoisted_10
      ])
    ]))
  }), 128))
}
}

})